export type MapPreviewSource =
  | { kind: "none" }
  | { kind: "selected"; url: string }
  | { kind: "saved"; url: string };

interface MapPreviewInput {
  selectedUrl?: string;
  savedUrl?: string;
}

// A selected (not yet saved) file wins over the saved map.
export const getMapPreviewSource = ({
  selectedUrl,
  savedUrl,
}: MapPreviewInput): MapPreviewSource => {
  if (selectedUrl) return { kind: "selected", url: selectedUrl };
  if (savedUrl) return { kind: "saved", url: savedUrl };
  return { kind: "none" };
};

// Returns the temporary object URL that must be released when it is replaced.
export const getUrlToRevoke = (
  previousUrl?: string,
  nextUrl?: string,
): string | undefined =>
  previousUrl && previousUrl !== nextUrl ? previousUrl : undefined;
